import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { ausrehabApi } from './slices/baseApi';
import { questionnaireFillApi } from './slices/apis/questionnaireFillApi';
import authSliceReducer from './slices/auth';
import errorSlice, { name as errorSliceName } from './slices/error';

const store = configureStore({
	reducer: {
		[ausrehabApi.reducerPath]: ausrehabApi.reducer,
		[questionnaireFillApi.reducerPath]: questionnaireFillApi.reducer,
		auth: authSliceReducer,
		[errorSliceName]: errorSlice,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(ausrehabApi.middleware, questionnaireFillApi.middleware),
});

setupListeners(store.dispatch);

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export default store;
